export default "__VITE_ASSET__DJubXjFb__"